// src/apiServices/companyService.js

import axios from 'axios';
import { APILogInIfo } from './APIs';



export const companyService = {
    /**
     * Get company info for login page
     * @param {number|null} branchId - Optional branch ID
     * @returns {Promise} Company info with name and logo
     */
    async getLoginInfo(branchId = null) {
        try {
            const response = await axios.get(APILogInIfo);
            return response.data;
        } catch (error) {
            console.error('Error fetching company info:', error);
            // Return default info on error
            return {
                status: 'error',
                data: {
                    name: 'Hospital Management System',
                    logo_url: null,
                    has_logo: false
                }
            };
        }
    }
};